// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"779b6b2c","674":"fc8856de","905":"33c2107e","966":"a0b637ad","975":"362f4c69"}[chunkId] + ".chunk.js";
};